<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="账号管理"
      title="账号管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :operation-width="180"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
    <AuthorizeDeviceDrawer ref="authorizeDeviceDrawerRef" @saved="tableRef?.refresh?.()" />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';
import type { BusinessRoleAdminVo } from '@/api/businessRole';
import AuthorizeDeviceDrawer from './AuthorizeDeviceDrawer.vue';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const authorizeDeviceDrawerRef = ref<any>();
const loading = ref(false);

const addInitValue = {
};
const conditionsInitValue = {
};

const roleOptions = ref<{ value: number; label: string }[]>([]);

const cleanConditions = (conditions: Record<string, any>) => Object.entries(conditions || {}).reduce((res, [key, val]) => {
  if (val === null || val === undefined || val === '') {
    return res;
  }
  res[key] = val;
  return res;
}, {} as Record<string, any>);

const buildColumns = () => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'name',
      label: '账号姓名',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'phone',
      label: '账号电话',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'password',
      label: '账号密码',
      type: 'password',
      rule: [{ required: true }],
    },
    {
      name: 'businessRoleId',
      label: '业务角色',
      type: 'searchSelect',
      isCondition: true,
      options: roleOptions.value,
      rule: [{ required: true }],
    },
    {
      name: 'authorizedDeviceCount',
      label: '授权设备',
      type: 'numberStr',
      hideCreate: true,
      hideEdit: true,
      render: ({ row }: { row: any }) => (row.authorizeAllDevices ? '全部设备' : `${row.authorizedDeviceCount || 0} 台`),
    },
  ]);
};

const operates = [
  {
    key: 'authorizeDevice',
    name: '授权设备',
    handler: (row: any) => {
      authorizeDeviceDrawerRef.value?.show(row);
    },
  },
];

const init = useBaseAsync(async() => {
  const res = await useApi().businessRoleApi.listBusinessRole({});
  roleOptions.value = ((res.data.data || []) as BusinessRoleAdminVo[]).map((role) => ({
    value: role.id!,
    label: role.name,
  }));
  buildColumns();
});

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().adminApi.pageAdminadmin({
      conditions: cleanConditions(filter.conditions),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在删除账号「${row.name || row.phone}」，请谨慎操作`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().adminApi.addAdminadmin({
    adminAdminVo: data,
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().adminApi.updateAdminadmin({
    adminAdminVo: data,
  });
  ElMessage.success('修改成功');
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().adminApi.delAdminadmin(data.id);
  ElMessage.success('删除成功');
});

init();
</script>
<style lang="scss" scoped>
</style>
